import Title from "antd/lib/typography/Title";
import { useAppSelector } from "../../hooks/hooks";
import { selectFullMidservice } from "../../redux/slices/midservice/midserviceSlice";
// import ReactJson from '@textea/json-viewer'
import { JsonViewer } from "@textea/json-viewer";
import React from "react";

export const InstanceStatus = (): JSX.Element => {
  // const dispatch = useAppDispatch();
  const fullInstance = useAppSelector(selectFullMidservice);

  return (
    <>
      <Title level={5}>Статус инстанса</Title>
      <JsonViewer value={fullInstance?.midserviceInstance.status} />
    </>
  );
};
